import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Table, Spin } from 'antd';

const SubscriptionManagement = () => {
  const [activeSubscribers, setActiveSubscribers] = useState([]);
  const [inactiveSubscribers, setInactiveSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const token = localStorage.getItem("adminToken");

  console.log("admintoken",token)


  const fetchSubscriptions = async () => {
    try {
      const response = await axios.get(
        "https://afric-fresh-backend.onrender.com/admin/fetch-subscriptions"
        // 'http://localhost:3005/admin/fetch-subscriptions'
        ,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }});
      const users = response.data;

      const active = users.filter(user => 
        user.subscription.some(sub => sub.status === 'active')
      );
      const inactive = users.filter(user => 
        !user.subscription.some(sub => sub.status === 'active')
      );

      setActiveSubscribers(active);
      setInactiveSubscribers(inactive);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching subscriptions:', error);
      Swal.fire('Error', 'Failed to fetch subscriptions.', 'error');
    }
  };

  const handleSendMonthlyEmail = async () => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'This will send a monthly reminder email to all active subscribers.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#007D44',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Proceed',
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: 'Sending Emails...',
        html: 'Please wait while we send the emails.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        await axios.post(
            "https://afric-fresh-backend.onrender.com/admin/send-monthly-email"
            // 'http://localhost:3005/admin/send-monthly-email'
            ,{
              headers: {
                Authorization: `Bearer ${token}`
              }});
        Swal.fire('Success', 'Monthly emails sent successfully!', 'success').then(() => {
          setTimeout(() => {
            Swal.close();
          }, 5000);
        });
      } catch (error) {
        console.error('Error sending emails:', error);
        Swal.fire('Error', 'Failed to send monthly emails.', 'error');
      }
    }
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'firstName',
      key: 'firstName',
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: 'Subscription Type',
      dataIndex: 'subscription',
      key: 'subscription',
      render: (subscription) => subscription.find(sub => sub.status === 'active')?.type || 'Not Subscribed',
      sorter: (a, b) => {
        const aType = a.subscription.find(sub => sub.status === 'active')?.type || 'Not Subscribed';
        const bType = b.subscription.find(sub => sub.status === 'active')?.type || 'Not Subscribed';
        return aType.localeCompare(bType);
      },
    },
    {
      title: 'Start Date',
      dataIndex: 'subscription',
      key: 'startDate',
      render: (subscription) => {
        const activeSub = subscription.find(sub => sub.status === 'active');
        return activeSub ? new Date(activeSub.startDate).toLocaleDateString() : 'N/A';
      },
      sorter: (a, b) => {
        const aDate = a.subscription.find(sub => sub.status === 'active')?.startDate || 0;
        const bDate = b.subscription.find(sub => sub.status === 'active')?.startDate || 0;
        return new Date(aDate) - new Date(bDate);
      },
    },
  ];

  return (
    <div>
      <h1>Subscription Management</h1>
      <button onClick={handleSendMonthlyEmail} style={{ marginBottom: '20px', backgroundColor: '#007D44', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}>
        Send Monthly Email
      </button>

      <h2>Active Subscribers</h2>
      {loading ? <Spin size="large" /> : <Table dataSource={activeSubscribers} columns={columns} rowKey="email" />}

      <h2>Inactive Subscribers</h2>
      {loading ? <Spin size="large" /> : <Table dataSource={inactiveSubscribers} columns={columns} rowKey="email" />}
    </div>
  );
};

export default SubscriptionManagement;